import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "template"];

  add(event) {
    event.preventDefault();
    const template = this.templateTarget.content.cloneNode(true);
    const row = template.querySelector(".nested-form-row");

    // Replace NEW_RECORD with unique index
    const newIndex = new Date().getTime();
    row.innerHTML = row.innerHTML.replace(/NEW_RECORD/g, newIndex);

    this.containerTarget.appendChild(row);
  }

  remove(event) {
    event.preventDefault();
    const row = event.currentTarget.closest(".nested-form-row");
    const destroyInput = row.querySelector("input[name*='[_destroy]']");

    if (destroyInput) {
      // Existing record: mark for destruction
      destroyInput.value = "1";
      row.classList.add("hidden");
    } else {
      // New record: remove from DOM
      row.remove();
    }
  }
}